const MAX_ERRORS_PER_SESSION = 10;
const ENDPOINT = `${import.meta.env.VITE_DEFAULT_URL.replace(/\/$/, '')}/log/frontend-error`;

let errorCount = 0;

function shouldIgnore(message, source) {
    if (!message) return true;

    // Cross-origin script errors with no useful info
    if (message === 'Script error.' || message === 'Script error') return true;

    // Browser extension errors
    if (source && (source.startsWith('chrome-extension://') || source.startsWith('moz-extension://'))) return true;

    // CORS/resource loading errors from S3 or other asset hosts (not actionable from frontend)
    if (message.includes('Access-Control-Allow-Origin')) return true;

    return false;
}

function send(payload) {
    if (errorCount >= MAX_ERRORS_PER_SESSION) return;
    errorCount++;

    fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
    }).catch(() => {
        // Fail silently — logging must never affect the user experience
    });
}

function buildPayload(message, stack, source) {
    return {
        service: 'whizr-web-platform',
        app_version: '1.0.0',
        message: String(message).slice(0, 1000),
        stack: stack ? String(stack).slice(0, 10000) : null,
        url: window.location.href,
        source: source || null,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
    };
}

export function initErrorLogger() {
    window.onerror = (message, source, _lineno, _colno, error) => {
        if (shouldIgnore(message, source)) return false;
        send(buildPayload(message, error?.stack, source));
        return false;
    };

    window.onunhandledrejection = (event) => {
        const message = event.reason?.message || String(event.reason);
        const stack = event.reason?.stack || null;
        if (shouldIgnore(message, null)) return;
        send(buildPayload(message, stack, null));
    };
}
